import React, { FunctionComponent } from 'react';

import { Stack, Typography } from '@mui/material';
import { WINDOW_V } from '../../constant/constants';

interface Props {
  title: string;
  text: string;
  widthTitle: string;
  widthText: string;
  height: string;
  windowState: number;
}

export const LendingDivItemText: FunctionComponent<Props> = ({
  title,
  text,
  widthTitle,
  widthText,
  height,
  windowState,
}) => (
  <Stack
    width="100%"
    paddingLeft={windowState === WINDOW_V ? '72px' : '300px'}
    justifyContent="center"
    spacing={2}
  >
    <Typography
      width={widthTitle}
      fontWeight={700}
      paddingTop="100px"
      fontFamily="Comfortaa"
      lineHeight={windowState === WINDOW_V ? '28px' : '48px'}
      fontSize={windowState === WINDOW_V ? '20px' : '36px'}
      letterSpacing="0.3px"
      textAlign="left"
      color="#000000"
      component="text"
    >
      {title}
    </Typography>
    <Typography
      width={widthText}
      paddingBottom="50px"
      fontWeight={400}
      fontFamily="Roboto"
      lineHeight={windowState === WINDOW_V ? '20px' : '24px'}
      fontSize={windowState === WINDOW_V ? '12px' : '14px'}
      letterSpacing="0.3px"
      textAlign="left"
      color="#000000"
      component="text"
    >
      {text}
    </Typography>
  </Stack>
);
